/**
 * WeaponWield enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file WeaponWield.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum WeaponWield {
  INVALID = 0,
  STUN_BATON = 1,
  ONE_HANDED_SWORD = 2,
  TWO_HANDED_SWORD = 3,
  BLASTER_PISTOL = 4,
  BLASTER_RIFLE = 5,
  BLASTER_HEAVY = 6,
}